var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgDaysLimit = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 39,
  height: 38,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "url(#days-limit_svg__a)",
  d: "M33.138 3.767H5.147c-.786 0-1.424.638-1.424 1.424v29.385c0 .786.638 1.424 1.424 1.424h27.99c.787 0 1.425-.638 1.425-1.424V5.19c0-.786-.638-1.424-1.424-1.424Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#EDCFFF",
  strokeWidth: 2,
  d: "M33.138 2.767H5.147A2.425 2.425 0 0 0 2.723 5.19v29.385A2.425 2.425 0 0 0 5.147 37h27.99a2.425 2.425 0 0 0 2.425-2.424V5.19a2.425 2.425 0 0 0-2.424-2.424Z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#days-limit_svg__b)",
  d: "M33.138 36H5.148a1.424 1.424 0 0 1-1.424-1.424V19.148h30.838v15.428c0 .786-.637 1.424-1.424 1.424Z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#days-limit_svg__c)",
  d: "M33.138 36H5.148a1.424 1.424 0 0 1-1.424-1.424v-2.99h30.838v2.99c0 .786-.637 1.424-1.424 1.424Z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#days-limit_svg__d)",
  d: "M35.861 32.535H2.425c-.915 0-1.593-.85-1.388-1.742l2.687-11.74h30.838l2.687 11.74a1.424 1.424 0 0 1-1.388 1.742Z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#days-limit_svg__e)",
  d: "M35.861 32.535H2.425c-.915 0-1.593-.85-1.388-1.742l2.687-11.74h30.838l2.687 11.74a1.424 1.424 0 0 1-1.388 1.742Z"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#days-limit_svg__f)",
  d: "M35.861 32.535c.915 0 1.592-.85 1.388-1.742l-2.687-11.74H3.724l13.482 13.482H35.86Z"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#days-limit_svg__g)",
  d: "M34.562 32.535H3.724v.047L7.142 36h25.996c.787 0 1.424-.638 1.424-1.424v-2.041Z"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M20.001 21.877V15.87c0-1.583.42-2.746 1.26-3.49.839-.743 1.961-1.114 3.365-1.114 1.404 0 2.53.371 3.376 1.114.847.744 1.27 1.907 1.27 3.49v6.008c0 1.584-.423 2.747-1.27 3.49-.847.743-1.972 1.115-3.376 1.115s-2.526-.372-3.366-1.115c-.84-.744-1.259-1.907-1.259-3.49Zm2.189 0c0 1.776.812 2.664 2.436 2.664.785 0 1.39-.22 1.817-.66.427-.441.64-1.109.64-2.004V15.87c0-.895-.213-1.562-.64-2.003-.427-.44-1.032-.66-1.817-.66-1.624 0-2.436.887-2.436 2.663v6.008ZM15.128 22.18c.058-.1.216-.363.476-.792.26-.428.462-.728.607-.9-.534.472-1.307.707-2.317.707-.953 0-1.805-.22-2.555-.663a4.698 4.698 0 0 1-1.733-1.821C9.202 17.94 9 17.083 9 16.14c0-1.014.238-1.907.715-2.678a4.794 4.794 0 0 1 1.992-1.82c.866-.429 1.862-.643 2.988-.643.982 0 1.877.214 2.685.643a4.565 4.565 0 0 1 1.905 1.82c.477.8.715 1.728.715 2.785 0 .685-.094 1.35-.282 1.992-.187.642-.62 1.62-1.299 2.934-.622 1.206-1.297 2.52-2.564 4.715a1.23 1.23 0 0 1-2.132-1.224l1.405-2.484Zm-.65-3.04c.88 0 1.603-.265 2.166-.793.577-.529.866-1.25.866-2.164 0-.913-.282-1.656-.845-2.227-.563-.586-1.27-.878-2.122-.878-.924 0-1.667.292-2.23.878-.549.571-.823 1.306-.823 2.206 0 .928.289 1.656.866 2.185.578.528 1.285.792 2.122.792Z"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#days-limit_svg__h)",
  d: "M27.083 19.053v2.824c0 .896-.213 1.563-.64 2.004-.426.44-1.032.66-1.816.66-1.625 0-2.438-.888-2.438-2.664v-2.824h-2.188v2.824c0 1.584.42 2.747 1.26 3.49.84.743 1.961 1.115 3.366 1.115 1.403 0 2.529-.372 3.375-1.116.847-.742 1.27-1.905 1.27-3.489v-2.824h-2.19Z"
})), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#days-limit_svg__i)",
  d: "m9.5 19 3.637 6.549c0 .218-.16 1.006.363 1.451.212.13.787.363 1.088.363.288 0 .507-.233.726-.363.22-.13.363-.144.363-.363L15.5 26.5l3.966-7.5H9.5Z"
})), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#days-limit_svg__j)",
  d: "m37.25 30.792-2.687-11.74V5.193c0-.787-.639-1.425-1.425-1.425h-.673c.786 0 1.424.638 1.424 1.424v13.862l2.687 11.74a1.424 1.424 0 0 1-1.388 1.742h.673c.915 0 1.593-.85 1.389-1.743Z"
})), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#days-limit_svg__k)",
  d: "M13.11 6.304a1.325 1.325 0 0 1-.423-.97V3.766h2.658l2.17 2.171a3.69 3.69 0 0 1 1.082 2.61c0 .716-.552 1.333-1.268 1.365a1.325 1.325 0 0 1-1.032-.42l-3.188-3.19Z"
})), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#days-limit_svg__l)",
  d: "M22.77 6.304a1.326 1.326 0 0 1-.423-.97V3.766h2.658l2.171 2.171a3.69 3.69 0 0 1 1.08 2.61c0 .716-.55 1.333-1.267 1.365a1.326 1.326 0 0 1-1.032-.42l-3.188-3.19Z"
})), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
  stroke: "#EDCFFF",
  strokeWidth: 2,
  d: "M3 19 1.037 30.793a1.424 1.424 0 0 0 1.388 1.742H3.5M35.5 19l1.75 11.793a1.424 1.424 0 0 1-1.389 1.742H34.5"
})), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#days-limit_svg__m)",
  d: "M23.497 6.806c-.801 0-1.451-.613-1.451-1.368V3.093c0-.755.65-1.367 1.451-1.367.802 0 1.452.612 1.452 1.367v2.345c0 .755-.65 1.368-1.452 1.368Z"
})), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#days-limit_svg__n)",
  d: "M14.063 6.806c-.802 0-1.452-.613-1.452-1.368V3.093c0-.755.65-1.367 1.452-1.367.801 0 1.451.612 1.451 1.367v2.345c0 .755-.65 1.368-1.451 1.368Z"
})), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#days-limit_svg__o)",
  d: "M23.677 1.726v4.937a1.33 1.33 0 0 0 1.329-1.33V3.056a1.33 1.33 0 0 0-1.33-1.33Z"
})), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#days-limit_svg__p)",
  d: "M14.242 1.726v4.937a1.33 1.33 0 0 0 1.33-1.33V3.056a1.33 1.33 0 0 0-1.33-1.33Z"
})), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
  stroke: "#EDCFFF",
  strokeWidth: 2,
  d: "M21.32 3.177a2.177 2.177 0 0 1 4.355 0M11.886 3.177a2.177 2.177 0 0 1 4.354 0"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "days-limit_svg__a",
  x1: 13.777,
  x2: 21.993,
  y1: 7.958,
  y2: 26.217,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C058FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#5548F3"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "days-limit_svg__b",
  x1: 8.605,
  x2: 29.779,
  y1: 15.748,
  y2: 38.636,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#D148F3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#5548F3"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "days-limit_svg__c",
  x1: 19.144,
  x2: 19.144,
  y1: 35.598,
  y2: 32.44,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#D148F3",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.179,
  stopColor: "#5548F3",
  stopOpacity: 0.179
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#5548F3"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "days-limit_svg__d",
  x1: 5.898,
  x2: 39.872,
  y1: 20.189,
  y2: 35.491,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C058FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#5548F3"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "days-limit_svg__e",
  x1: 19.143,
  x2: 19.143,
  y1: 31.237,
  y2: 33.136,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#5548F3",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#5548F3"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "days-limit_svg__f",
  x1: 25.584,
  x2: 4.061,
  y1: 25.493,
  y2: 3.97,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#5548F3",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#5548F3"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "days-limit_svg__g",
  x1: 16.879,
  x2: 13.353,
  y1: 29.755,
  y2: 25.389,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#5548F3",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.179,
  stopColor: "#5548F3",
  stopOpacity: 0.179
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#5548F3"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "days-limit_svg__h",
  x1: 24.637,
  x2: 24.637,
  y1: 21.476,
  y2: 10.64,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#9A5BFF",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.179,
  stopColor: "#9A5BFF",
  stopOpacity: 0.179
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#9A5BFF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "days-limit_svg__i",
  x1: 18.015,
  x2: 18.015,
  y1: 21.407,
  y2: 10.642,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#9A5BFF",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.179,
  stopColor: "#9A5BFF",
  stopOpacity: 0.179
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#A848F3"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "days-limit_svg__j",
  x1: 34.596,
  x2: 27.331,
  y1: 18.061,
  y2: 19.96,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#5548F3",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#5548F3"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "days-limit_svg__k",
  x1: 16.73,
  x2: 13.916,
  y1: 7.538,
  y2: 4.723,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#5548F3",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#5548F3"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "days-limit_svg__l",
  x1: 26.391,
  x2: 23.576,
  y1: 7.538,
  y2: 4.723,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#D148F3",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#2D1EED"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "days-limit_svg__m",
  x1: 23.498,
  x2: 23.498,
  y1: 1.795,
  y2: 17.474,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFC200"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.268,
  stopColor: "#FB0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.659,
  stopColor: "#FFA801"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FF9102"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "days-limit_svg__n",
  x1: 14.063,
  x2: 14.063,
  y1: 1.795,
  y2: 17.474,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFC200"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.268,
  stopColor: "#FB0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.659,
  stopColor: "#FFA801"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FF9102"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "days-limit_svg__o",
  x1: 23.891,
  x2: 25.09,
  y1: 4.193,
  y2: 4.193,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFC200",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.203,
  stopColor: "#FB0",
  stopOpacity: 0.203
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.499,
  stopColor: "#FFA700",
  stopOpacity: 0.499
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.852,
  stopColor: "#F80",
  stopOpacity: 0.852
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FF7800"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "days-limit_svg__p",
  x1: 14.457,
  x2: 15.655,
  y1: 4.193,
  y2: 4.193,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFC200",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.203,
  stopColor: "#FB0",
  stopOpacity: 0.203
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.499,
  stopColor: "#FFA700",
  stopOpacity: 0.499
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.852,
  stopColor: "#F80",
  stopOpacity: 0.852
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FF7800"
})))));
export { SvgDaysLimit as ReactComponent };
export default "data:image/svg+xml;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiYTJlOTg4Y2M0MDQ1YWJlZWJlODYyYTZlZGU1ZTVkZDYuc3ZnIjs=";